export default __webpack_public_path__ + "static/media/close.0dd9e28a.svg";